var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    stroke: "#0087ff",
    d: "M10.07 20.064c-6.376 0-8.7 3.478-8.7 7.826h17.535c-.145-4.348-2.753-7.826-8.835-7.826zM16.151 9.195v3.333a6.185 6.185 0 01-6.231 6.231h0a6.185 6.185 0 01-6.232-6.231V9.05M.645 2.674A4.324 4.324 0 014.413.5v.725a1.56 1.56 0 001.159 1.449M.5 2.964c0-.145.145-.29.145-.435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    stroke: "#0087ff",
    d: "M10.5 2.674h1.3a4.36 4.36 0 014.348 4.348v4.352h-.435c-.87 0-1.3-.435-1.3-1.159s-.29-1.014-1.159-1.014H4.413A4.256 4.256 0 01.5 6.587M8.181 2.674h.435"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4096ff",
    d: "M14.907 11.235l-.372-.331a.572.572 0 01-.062-.269v-.455a1.254 1.254 0 00-1.262-1.262H4.625a4.327 4.327 0 01-3.166-1.386 4.065 4.065 0 013.038-6.145v.124a1.293 1.293 0 00.559 1.055 1.248 1.248 0 001.2.869h5.173a5.069 5.069 0 013.807 1.717 4.994 4.994 0 01.786 2.69v1.076l-.29 2.338h-.635a.2.2 0 01-.19-.021z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ef5f9163.svg";
export { ForwardRef as ReactComponent };